import React from 'react';
import BaseSectionTitle from '../../siteBaseSections/baseSectionComponents/BaseSectionTitle/BaseSectionTitle';
import CallToAction from '../../shared/CallToAction/CallToAction';

export default function SetupCompleteMessage() {
  const titleContent = (
    <>
      Your account setup is complete{' '}
      <span className="material-icons" style={{ color: '#2CBF31' }}>
        check_circle
      </span>
    </>
  );

  return (
    <>
      <BaseSectionTitle small text={titleContent} />
      <div style={{ marginBottom: 30 }}>
        <p>
          When the event opens, you'll see the <strong>Log In</strong> button
          appear on the home page, and in advance we'll send you information on
          how best to prepare for the event and get the most out of it.
        </p>
      </div>
      <CallToAction
        size="submit"
        ctaConfig={{ type: 'HOME_LINK' }}
        label="Go to homepage"
      />
    </>
  );
}
